import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import tw, { styled } from "twin.macro"

import ButtonLE from "components/button-le"

import { brandRules } from "utils/brand"
const PremiumNotice = styled.div`
  ${tw`font-body text-base text-grey-10`}
  font-size: 15px;
  line-height: 30px;
  @media (min-width: 640px) {
    font-size: 17px;
    line-height: 34px;
  }
  margin-top: -40px;
  padding-bottom: 130px;
  position: relative;

  .blurred {
    padding-top: 20px;
    color: transparent;
    text-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
    user-select: none;
  }

  .CTA {
    position: absolute;
    top: 50px;

    &.shared {
      position: relative;
    }

    h2 {
      ${tw`font-display font-bold`}
      letter-spacing: 0;
      text-align: center;
      margin-bottom: 30px;
      font-size: 30px;
      line-height: 41px;
      @media (min-width: 1100px) {
        font-size: 45px;
        line-height: 64px;
      }
    }

    .link-caption {
      ${tw`text-black`}
    }
  }
`

const BlockedContent = ({ shared }) => {
  const data = useStaticQuery(graphql`
    query {
      gcms {
        blockedContent: contentBlocks(
          where: { identifier: "premium-content-blocked" }
        ) {
          title
          mainContent {
            html
          }
          callToAction
          linkUrl
        }
        sharedContent: contentBlocks(
          where: { identifier: "shared-premium-insight-cta" }
        ) {
          title
          mainContent {
            html
          }
          callToAction
          linkUrl
        }
      }
    }
  `)
  const cb = shared ? data.gcms.sharedContent[0] : data.gcms.blockedContent[0]

  return (
    <PremiumNotice>
      <div className="max-w-s mx-auto m:max-w-m l:max-w-l flex flex-row">
        <div className="flex-shrink-0 w-1/6 hidden l:block"></div>
        <div
          className="blurred"
          dangerouslySetInnerHTML={{ __html: cb.mainContent.html }}
        />
        <div className="flex-shrink-0 w-1/6 hidden l:block"></div>
      </div>
      <div className={`CTA w-full ${shared ? "shared" : ""}`}>
        <div className="mx-auto w-8/12 flex flex-col items-center">
          <h2 dangerouslySetInnerHTML={{ __html: brandRules(cb.title) }} />
          <ButtonLE className="text-grey-10" to={cb.linkUrl}>
            <span
              dangerouslySetInnerHTML={{
                __html: brandRules(cb.callToAction),
              }}
            />{" "}
          </ButtonLE>
        </div>
      </div>
    </PremiumNotice>
  )
}

export default BlockedContent
